import { render } from "./ShowPlanetaryStrength.vue?vue&type=template&id=214c7f37&scoped=true"
import script from "./ShowPlanetaryStrength.vue?vue&type=script&lang=js"
export * from "./ShowPlanetaryStrength.vue?vue&type=script&lang=js"

import "./ShowPlanetaryStrength.vue?vue&type=style&index=0&id=214c7f37&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214c7f37"]])

export default __exports__